import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const units = [{
    value: pad(hours),
    label: 'Hours'
  }, {
    value: pad(minutes),
    label: 'Min'
  }, {
    value: pad(seconds),
    label: 'Sec'
  }];
  return <div className="flex w-full flex-col items-center gap-2" data-id="element-18" data-mp="34qs1qxk9bee2">
      <p className="flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-[0.14em] text-brick-600 sm:text-xs" data-id="element-19" data-mp="34pz0gc42hh3b">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-20" data-mp="1c0opeh1xhlqq" />
        This $27 price expires in
      </p>
      <div className="flex items-start gap-1.5" role="timer" aria-live="off" aria-label={`Offer expires in ${pad(hours)} hours ${pad(minutes)} minutes ${pad(seconds)} seconds`} data-id="element-21" data-mp="1gzi3obp1hgry">
        {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-22" data-mp="171u7rifp6387" data-mpi={index}>
            <div className="flex w-[62px] flex-col items-center rounded-xl bg-navy-900 px-1 py-2 sm:w-[74px] sm:py-2.5" data-id="element-23" data-mp="1urg7c6zzekgq">
              <span className="font-display text-2xl font-bold tabular-nums leading-none text-white sm:text-3xl" data-id="element-24" data-mp="1zp7w4s5bxqgp">
                {unit.value}
              </span>
              <span className="mt-1 text-[9px] font-bold uppercase tracking-[0.12em] text-navy-200 sm:text-[10px]" data-id="element-25" data-mp="1q0g7asvkfma0">
                {unit.label}
              </span>
            </div>
            {index < units.length - 1 ? <span className="pt-2 font-display text-2xl font-bold text-navy-300 sm:text-3xl" aria-hidden="true" data-id="element-26" data-mp="2ih0p4mkefbof">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
    </div>;
}